// extracted by mini-css-extract-plugin
module.exports = {"root":"Summary_root__3Qs8h","section":"Summary_section__1Lcor","danger":"Summary_danger__2LIFf"};